// extracted by mini-css-extract-plugin
module.exports = {"orderHistory-navigation":"+BnCL","orderHistory-content":"ma6xm","orderHistory-content-date":"fIZ0o"};